module.exports = __webpack_public_path__ + "img/point4.b09b7713.png";